const avatars = [
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/10.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/11.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/12.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/2.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/3.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/4.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/5.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/6.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/7.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/8.png",
  },
  {
    Key: "avtar-04",
    image: "https://baatein.s3.ap-south-1.amazonaws.com/images/avatars/9.png",
  },
];

export default avatars;
